module.exports = __webpack_public_path__ + "static/media/1026218.a44ca670.jpg";